<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Solicitudes de permiso por aprobar Recursos Humanos
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionAprobar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionAprobar = false"
        @do="aprobar"
        ref="confirmarAprobar"
      )
        span(slot="title") ¿Desea aprobar la solicitud?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Aprobando...
          template(v-else)
            | Aprobar
        strong Al aprobar, se crearan los permisos y no se podrán hacer cambios.

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionRechazar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionRechazar = false"
        @do="rechazar"
        ref="confirmarRechazar"
      )
        span(slot="title") ¿Desea rechazar la solicitud?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Rechazando...
          template(v-else)
            | Rechazar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionRechazarMasiva"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionRechazarMasiva = false"
        @do="rechazarMasivo"
        ref="confirmarRechazarMasiva"
      )
        span(slot="title") ¿Desea rechazar masivamente?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Rechazando...
          template(v-else)
            | Rechazar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionAprobarMasiva"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionAprobarMasiva = false"
        @do="aprobarMasivo"
        ref="confirmarAprobarMasiva"
      )
        span(slot="title") ¿Desea aprobar masivamente?
        span(slot="primaryAction")
          template(v-if="isSending")
            | Aprobando...
          template(v-else)
            | Aprobar
    .acciones.display-flex.aic.jcc.mb-10(v-if="isSeleccionMasiva")
      button.button.is-small.margin-right-5(@click="confirmarAprobarMasivo")
        span.icon.is-small
          i.fa.fa-paper-plane-o
        span Aprobar
      button.button.is-small.is-danger(@click="confirmarRechazoMasivo")
        span.icon.is-small
          i.fa.fa-times
        span Rechazar
    .body
      transition-group.contenedor-transition(name="fade-smooth-two", tag="div")
        loading(v-if="isLoading", key="loading")
        .mensaje-informacion(key="mensaje_no_solicitudes", v-if="lista.length === 0 && !isLoading && mostrarMensajeDeNoSolicitudes")
          .message.is-info
            .message-body
              span No hay solicitudes para aprobar
        .is-desktop(key="table-solicitud-por-aprobar")
          table.table.is-striped.is-bordered(key="table-solicitud-por-aprobar", v-if="lista.length > 0")
            thead
            thead
              th
                input(type="checkbox", name="solicitud", :checked="seleccionadosTodos", @change="check('all')")
              th Empleado
              th Tipo
              th Motivo
              th Acciones
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="(o,index) in lista"
                :key="index+o.id+''"
              )
                td.ta-center
                  input(type="checkbox", :id="o.id", :checked="o.seleccionado", @change="check(o)")
                td.text-center
                  .hint--top(:aria-label="'Empleado: ' + o.dniEmpleado")
                    span.hint--bottom(:aria-label="'Solicitud: ' + o.id")
                      | {{ o.nombreEmpleado }}
                td {{ o.descripcionTipo }}
                td
                  template(v-if="o.motivo")
                    span {{ o.motivo }}
                  template(v-else)
                    span Sin motivo
                  br
                  .dias-pedidos
                    strong Dias pedidos
                    div(v-for="i in o.detalle")
                      span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
                td.text-center
                  template(v-if="o.adjunto")
                      a.button.is-small(:href="o.adjunto", target="_blank")
                        span.icon.is-small
                              i.fa.fa-paperclip.is-small.fs-12
                        span Ver adjunto
                  template(v-else)
                    span Sin adjunto
                  .contenedor-acciones(v-if="!isSeleccionMasiva")
                    button.button.is-small(@click="confirmarAprobar(o)")
                      span.icon.is-small
                        i.fa.fa-paper-plane-o
                      span Aprobar
                    button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                      span.icon.is-small
                        i.fa.fa-times
                      span Rechazar
        .is-mobile(key="mobile-solicitud-por-aprobar")
          .box(
            v-for="(o, index) in lista"
            :key="index"
          )
            .checkbox
              input(type="checkbox", :id="o.id", :checked="o.seleccionado", @change="check(o)")
            .descripcion-tipo.hint--top(:aria-label="'Empleado: ' + o.dniEmpleado")
              span.is-bold.hint--bottom(:aria-label="'Solicitud: ' + o.id")
                | {{ o.nombreEmpleado }}
            .descripcion-tipo
              span {{ o.descripcionTipo }}
            .motivo
              div
                span {{ o.motivo }}
            .dias-pedidos
              strong Dias pedidos
              div(v-for="i in o.detalle")
                span.detalle-dias {{ i.desde === i.hasta ? i.desde : `${i.desde} - ${i.hasta}` }}   {{ i.horaDesde }}-{{ i.horaHasta }}
            .botones
              template(v-if="o.adjunto")
                a.button.is-small(:href="o.adjunto", target="_blank")
                  span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                  span Ver adjunto
              template(v-if="!isSeleccionMasiva")
                button.button.is-small(@click="confirmarAprobar(o)")
                  span.icon.is-small
                    i.fa.fa-paper-plane-o
                  span Aprobar
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
          .acciones.display-flex.aic.jcc.mb-10.mt-10(v-if="isSeleccionMasiva")
            button.button.is-small.margin-right-5(@click="confirmarAprobarMasivo")
              span.icon.is-small
                i.fa.fa-paper-plane-o
              span Aprobar
            button.button.is-small.is-danger(@click="confirmarRechazoMasivo")
              span.icon.is-small
                i.fa.fa-times
              span Rechazar

</template>

<script>
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
export default {
  name: 'lista_solicitud_permisos_por_aprobar_rrhh_component',
  data () {
    return {
      lista: [],
      seleccionadosTodos: false,
      mostrarConfirmacionAprobarMasiva: false,
      mostrarConfirmacionRechazarMasiva: false,
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionRechazar: false,
      mostrarMensajeDeNoSolicitudes: true,
      isSending: false,
      isLoading: true
    }
  },
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.fetch()
  },
  computed: {
    isSeleccionMasiva () {
      return this.lista.filter(o => o.seleccionado).length > 0
    }
  },
  methods: {
    check (row) {
      if (row === 'all') {
        this.seleccionadosTodos = !this.seleccionadosTodos
        for (let i = 0; i < this.lista.length; i++) {
          this.$set(this.lista[i], 'seleccionado', this.seleccionadosTodos);
        }
        return
      }
      row.seleccionado = !row.seleccionado
      if (!row.seleccionado) {
        this.seleccionadosTodos = false
      }
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/permisos/rrhh/poraprobar', obj, function (data) {
        vm.lista = data.lista
        // esto replica la lista 3 veces
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 651})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 800})));
        // vm.lista.push(...data.lista.map(obj => ({...obj, id: obj.id + 1452})));
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    confirmarAprobar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionAprobar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarAprobar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarRechazoMasivo () {
      this.mostrarConfirmacionRechazarMasiva = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazarMasiva.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarAprobarMasivo () {
      this.mostrarConfirmacionAprobarMasiva = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarAprobarMasiva.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    aprobar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: vm.solicitudSeleccionada.id
      }
      apiPost(vm, '/permisos/solicitud/aprobar/rrhh', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Aprobado correctamente')
        vm.mostrarConfirmacionAprobar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    rechazar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: this.solicitudSeleccionada.id
      }

      apiDelete(vm, '/permisos/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    aprobarMasivo () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        ids: vm.lista.filter(o => o.seleccionado).map(o => o.id)
      }
      apiPost(vm, '/permisos/solicitud/masivo/aprobar/rrhh', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Aprobado correctamente')
        vm.mostrarConfirmacionAprobarMasiva = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    rechazarMasivo () {
      var vm = this
      if (vm.isLoading) return
      vm.isLoading = true
      var obj = {
        ids: vm.lista.filter(o => o.seleccionado).map(o => o.id)
      }
      apiDelete(vm, '/permisos/empleado/masivo/solicitud', obj, function (data) {
        vm.isLoading = false
        vm.mostrarConfirmacionRechazarMasiva = false
        notify(vm, 'success', 'Éxito', 'Solicitudes rechazadas')
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .checkbox
    position: absolute;
    top: 10px;
    left: 12px;
    margin-bottom: 1px;
    input
      transform: scale(1.5);
  .is-bold
    font-weight bold
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .contenedor-acciones
    padding-top 4px
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }


  .position-relative
    position relative

  .quitar
    margin-left 5px
    cursor pointer
    i
      font-size 15px

  .dias-pedidos
    font-size 12px
    color #9a9a9a

  td
    vertical-align: middle;

  .mensaje-informacion
    margin-bottom 10px


  .contenedor-transition
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
  .fs-12
    font-size 12px
  .is-mobile
    display none
    .box
      position: relative;
    .status
      position:absolute;
      top: -3px
      right: 5px
      span {
        font-size: 10px;
        color #a5a5a5
        font-weight: bold;
      }
    .descripcion-tipo
      margin-bottom 5px
    .motivo
      background-color: #eff5fb;
      color: #296fa8;
      padding: 10px
    .botones
      display flex
      justify-content center
      margin-top 10px
      .button
        margin-right 5px
        &:last-child
          margin-right 0px

  @media (max-width 640px)
    .is-mobile
      display block

    .is-desktop
      display none
</style>



// WEBPACK FOOTER //
// Component_Permisos_Lista_Solicitudes_Por_Aprobar_RRHH.vue?51ef1587